module.exports = __webpack_public_path__ + "static/img/bg-landing.de6cdc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-landing.png
// module id = s3M3
// module chunks = 1